/***
 * @file:
 * @author: caojianping
 * @Date: 2021-05-24 18:59:18
 */
import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { Subscription } from 'rxjs';

import { I18NService } from '@ithinkdt/shared/i18n';

import { NoticeIconSelect, NoticeItem } from '../notify.model';

@Component({
  selector: 'dt-notice-icon',
  templateUrl: './notice-icon.component.html',
  styleUrls: ['./notice-icon.component.scss'],
})
export class NoticeIconComponent {
  private i18n$: Subscription;

  // æç¤ºè¯­
  locale: any = {};
  @Input() data: NoticeItem[] = [];
  /** å¾æ ä¸çæ¶æ¯æ»æ° */
  @Input() count: number;
  /** å¼¹åºå¡çå è½½ç¶æ */
  @Input() loading = false;
  @Output() select = new EventEmitter<NoticeIconSelect>();
  @Output() clear = new EventEmitter<string>();
  /** æå¨æ§å¶Popoveræ¾ç¤º */
  @Input() popoverVisible = false;
  @Output() popoverVisibleChange = new EventEmitter<boolean>();

  constructor(private i18n: I18NService) {
    // this.i18n$ = this.i18n.change.subscribe(
    //   () => (this.locale = this.i18n.getData('noticeIcon')),
    // );
  }

  onVisibleChange(result: boolean) {
    this.popoverVisibleChange.emit(result);
  }

  onSelect(i: any) {
    this.select.emit(i);
  }

  onClear(title: string) {
    this.clear.emit(title);
  }
}
